import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import DamageTypesSection from './sections/DamageTypesSection';
import WarningBanner from './sections/WarningBanner';
import ContentGridSection from './sections/ContentGridSection';
import VerificationProcessSection from './sections/VerificationProcessSection';
import FAQSection from './sections/FAQSection';
import ReportBanner from './sections/ReportBanner';
import TrustSection from './sections/TrustSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <DamageTypesSection />
        <WarningBanner />
        <ContentGridSection />
        <VerificationProcessSection />
        <FAQSection />
        <ReportBanner />
        <TrustSection />
      </main>
      <Footer />
    </>
  );
}